module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "crud-dialog"
  }, [_c('v-card-title', {
    staticClass: "headline"
  }, [_c('v-icon', [_vm._v("add")]), _vm._v(" Agregar documento del trámite de la entidad\r\n    "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$store.commit('closeModal', 3)
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('v-alert', {
    attrs: {
      "color": "info",
      "icon": "info",
      "value": true
    }
  }, [_vm._v("\r\n      Se agregará el trámite de la entidad en base a los trámites registrados en el "), _c('strong', [_vm._v("Portal único de trámites")]), _vm._v(" y la "), _c('strong', [_vm._v("Plataforma de pagos")]), _vm._v(".\r\n    ")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.mydocs.portal,
      "label": "Documentos",
      "item-text": "nombre",
      "item-value": "codigo_portal",
      "autocomplete": "",
      "noDataText": "No hay resultados"
    },
    model: {
      value: (_vm.documento),
      callback: function($$v) {
        _vm.documento = $$v
      },
      expression: "documento"
    }
  }), _vm._v(" "), (_vm.showUsuariosApp) ? _c('div', [(_vm.mydocs.usuariosApp.length > 1) ? _c('v-alert', {
    attrs: {
      "color": "info",
      "icon": "info",
      "value": true
    }
  }, [_vm._v("\r\n        Seleccione una Aplicación que esté asociada al trámite que quiere crear, de la misma forma en que lo hace en la Plataforma de Pagos\r\n      ")]) : _vm._e(), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.mydocs.usuariosApp,
      "label": "Aplicación en la Plataforma de pago",
      "item-text": "endpoint",
      "item-value": "id_usuario_app",
      "readonly": _vm.mydocs.usuariosApp.length == 1,
      "autocomplete": "",
      "noDataText": "No hay resultados"
    },
    model: {
      value: (_vm.usuarioapp),
      callback: function($$v) {
        _vm.usuarioapp = $$v
      },
      expression: "usuarioapp"
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.showUsuariosApp && _vm.documento) ? _c('v-alert', {
    attrs: {
      "color": "warning",
      "icon": "warning",
      "value": true
    }
  }, [_vm._v("\r\n      El documento seleccionado no tiene asociado ninguna Aplicación en la Plataforma de Pagos\r\n    ")]) : _vm._e()], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    nativeOn: {
      "click": function($event) {
        return _vm.$store.commit('closeModal', 3)
      }
    }
  }, [_c('v-icon', [_vm._v("cancel")]), _vm._v(" Cancelar\r\n    ")], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "disabled": !_vm.show || _vm.loading
    },
    on: {
      "click": function($event) {
        return _vm.obtainTokenForDocument()
      }
    }
  }, [_c('v-icon', [_vm._v("check_circle")]), _vm._v(" Crear trámite\r\n    ")], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3b532314","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/eApostilla/documento/AddDocs.vue
// module id = 509
// module chunks = 2